export default __webpack_public_path__ + "static/media/electric-car.394ec00f.png";